import React from "react";

import { Button, Tag, TagLabel } from "@chakra-ui/react";

import { DocusignEnvelopeStatusEnum } from "../../../graphql/generated/definitions";

import useTranslations from "../../../hooks/useTranslations";

type SignatureStatusProps = {
  status: DocusignEnvelopeStatusEnum;
  document: string | null;
};

function getAlertColorByStatus(status: DocusignEnvelopeStatusEnum) {
  switch (status) {
    case "draft":
    case "sent":
    case "created":
    case "delivered":
    case "processing":
    case "signed":
      return "blue";
    case "declined":
    case "deleted":
    case "voided":
      return "yellow";
    case "completed":
      return "green";
  }
}

const ReportSignatureStatus: React.FC<SignatureStatusProps> = ({
  status,
  document,
}) => {
  const t = useTranslations();

  if (!status) return null;

  const color = getAlertColorByStatus(status);

  if (status === "completed" && document) {
    return (
      <Button
        as={"a"}
        href={document}
        target="_blank"
        size="sm"
        variant="outline"
        color="darkBrand"
        id="report-signature"
      >
        {t("reports.signature.downloadSignedReport")}
      </Button>
    );
  }

  return (
    <Tag size="lg" variant="outline" colorScheme={color}>
      <TagLabel fontSize="sm">
        {t(`reports.signature.status.${status}` as const)}
      </TagLabel>
    </Tag>
  );
};

export default ReportSignatureStatus;
